import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { searchProducts } from "../../services/productApi";
import ShopHeader from "./ShopHeader";
import "./search.css";

const SearchPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const query = params.get("q");

  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (query) fetchResults();
  }, [query]);

  const fetchResults = async () => {
  try {
    const data = await searchProducts(query);

    console.log("SEARCH RESULT (PAGE):", data);

    setProducts(Array.isArray(data) ? data : data.products || []);
  } catch (err) {
    console.log(err);
  }
};

  return (
    <div className="shop-page">

      {/* HEADER */}
      <ShopHeader
        categories={[]}
        selectedCategory="All"
        onCategoryClick={() => {}}
      />

      {/* RESULTS */}
      <div className="search-page">
        <h2>Results for "{query}"</h2>

        <div className="product-grid">
          {products.length > 0 ? (
            products.map((p) => (
              <div
                key={p.id}
                className="product-card"
                onClick={() => navigate(`/product/${p.id}`)}
              >
                <img
                  src={
                    p.images?.[0]
                      ? `${p.images[0]}`
                      : "https://via.placeholder.com/300"
                  }
                  alt=""
                />
                <h3>{p.name}</h3>
                <p>₹{p.price}</p>
              </div>
            ))
          ) : (
            <p>No products found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchPage;